/**
 * liu.jinming 2018-3-13
 */
'use strict';
angular.module('manualUploadModule', []).controller('manualUploadCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$filter',
    'trsHttpService',
    'paperId',
    'item',
    'Upload',
    'editingCenterService',
    'modalDialog',
    '$rootScope',
    '$sessionStorage',
    'globleParamsSet',
    function(
        $scope,
        $q,
        $modalInstance,
        $filter,
        trsHttpService,
        paperId,
        item,
        Upload,
        editingCenterService,
        modalDialog,
        $rootScope,
        $sessionStorage,
        globleParamsSet
    ) {
        initStatus();
        initData();

        /** [initStatus description]初始化状态 */
        function initStatus() {
            $scope.status = {
                imgSrc: true, // 图片 验证通过那个
                time: true, // 见报日期
                diePosition: true,
                banPositon: true,
                zuPeople: true, // 表单验证
                diePositionChange: false, // 叠次通过下拉框改变
                changeCont: angular.isDefined(item) ? '编辑' : '添加',
            };

            $scope.data = {
                diePosition: {
                    name: '请选择叠次',
                    value: '',
                }, // 叠次
                banPositon: {
                    name: '请选择版面',
                    value: '',
                },

                // 版面
                diePositions: [
                    {
                        name: '请选择叠次',
                        value: '',
                    },
                ],
                banPositons: [
                    {
                        name: '请选择版面',
                        value: '',
                    },
                ],

                uploadInfo: {
                    imgSrc: '', // 图片
                    time: '', // 见报日期
                    diePosition: '',
                    banPositon: '',
                    zuPeople: '',
                },
                ALLitems: [],
            };
            if (item) {
                $scope.add = false;
            } else {
                $scope.add = true;
            }
            $scope.$watch('pubDate', function(newValue, oldValue) {
                if ($scope.pubDate != '' && newValue != oldValue) {
                    $scope.data.uploadInfo.time = $filter('date')(newValue, 'yyyy-MM-dd').toString();
                }
            });
            if (!!item) {
                // 编辑状态
                $scope.data.uploadInfo = angular.copy(item);
            }
        }

        /** [initData description]初始化数据 */
        function initData() {
            if (!!item) {
                $scope.pubDate = item.time;
                queryDieCis();
            } else {
                getSystemTime();
                getCurrentUser();
                var dieciBanmianMermory = window.localStorage['dieciBanmianMermory'];
                var dieciMermory, banmianMermory;
                queryDieCis().then(function() {
                    // 前面的人已经把代码写的这么混乱了，我这边按照他的思路做个兼容，有空来彻底重构，标记一下
                    if (!dieciBanmianMermory) {
                        return;
                    }
                    dieciBanmianMermory = JSON.parse(dieciBanmianMermory);
                    dieciMermory = dieciBanmianMermory.dieci;
                    var flag = false;
                    for (var i = 0; i < $scope.data.diePositions.length; i++) {
                        var dieci = $scope.data.diePositions[i];
                        if (dieci.name === dieciMermory.name) {
                            flag = true;
                            $scope.data.diePosition = angular.copy(dieci);
                            $scope.data.uploadInfo.diePosition = dieci.name;
                            $scope.data.uploadInfo.diePositionId = $scope.data.diePosition.value;
                            break;
                        }
                    }
                    if (flag) {
                        editingCenterService
                            .getSiteInfo(paperId)
                            .then(function(data) {
                                return queryCaiBianBanMians(data);
                            })
                            .then(function() {
                                banmianMermory = dieciBanmianMermory.banmian;
                                for (var j = 0; j < $scope.data.banPositons.length; j++) {
                                    var banmian = $scope.data.banPositons[j];
                                    if (banmian.name === banmianMermory.name) {
                                        $scope.data.banPositon = angular.copy(banmian);
                                        $scope.data.uploadInfo.banPositon = $scope.data.banPositon.name;
                                        $scope.data.uploadInfo.banPositonId = $scope.data.banPositon.value;
                                        break;
                                    }
                                }
                            });
                    }
                });
            }
            // queryTenantUser();
            // editingCenterService.getSiteInfo(paperId).then(function(data) {
            //     queryCaiBianBanMians(data);
            // });
        }

        /**
         * [getCurrentUser description] 获取当前登录用户
         * @return {[type]} [description]
         */
        function getCurrentUser() {
            // var user = JSON.parse(window.localStorage["ls.mlfCachedUser"]); // session改变
            var user = $sessionStorage.get('mlfCachedUser');
            if (user && user.UserName) {
                $scope.data.uploadInfo.zuPeople = user.UserName;
            }
        }

        /**
         * [queryDieCis description] 查询叠次
         * @return {[type]} [description]
         */
        function queryDieCis() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: paperId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.diePositions = toNewarr('CHNLDESC', 'CHANNELID', data);
                $scope.data.diePositions.unshift($scope.data.diePosition);
                deffer.resolve();
                if (!!item) {
                    initSelect('diePosition');
                }
            });
            return deffer.promise;
        }

        /**
         * [initSelect description] 初始化下拉框选中项
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        function initSelect(type) {
            var newType = type + 's';
            var flag = false;
            for (var i = 0; i < $scope.data[newType].length; i++) {
                if ($scope.data[newType][i].name == item[type]) {
                    $scope.data[type] = $scope.data[newType][i];
                    flag = true;
                    break;
                }
            }
            if (!flag) {
                $scope.data[type] = $scope.data[newType][0];
                // 根据叠次查版面
                if (type == 'diePosition') {
                    delete $scope.data.banPositons;
                    $scope.data.banPositons = [
                        {
                            name: '请选择版面',
                            value: '',
                        },
                    ];
                    $scope.data.banPositon = {
                        name: '请选择版面',
                        value: '',
                    };
                    $scope.data.uploadInfo.banPositon = '';
                    return;
                }
            }
            // 根据叠次查版面
            if (type == 'diePosition') {
                editingCenterService.getSiteInfo(paperId).then(function(data) {
                    queryCaiBianBanMians(data);
                });
            }
        }

        /**
         * [queryCaiBianBanMians description] 版面查询
         * @return {[type]} [description]
         */
        function queryCaiBianBanMians(item) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryCaiBianBanMians',
                DieCiId: $scope.data.uploadInfo.diePositionId,
            };
            if (item.ISZHAOPAI == '1') {
                params.methodname = 'queryZhaoPaiBanMians';
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.banPositons = toNewarr('CHNLDESC', 'CHANNELID', data.DATA || data);
                $scope.data.banPositons.unshift($scope.data.banPositon);
                deffer.resolve();
                if (!!item && !$scope.status.diePositionChange) {
                    initSelect('banPositon');
                }
            });
            return deffer.promise;
        }

        /**
         * [queryTenantUser description] 组版人查询
         * @return {[type]} [description]
         */
        // function queryTenantUser() {
        //     var params = {
        //         serviceid: "mlf_usermanagement",
        //         methodname: "queryTenantUser"
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
        //         $scope.data.zuPeoples = toNewarr("TRUENAME", "", data);
        //         $scope.data.zuPeoples.unshift($scope.data.zuPeople);
        //         if (!!item) {
        //             initSelect("zuPeople");
        //         }
        //     });
        // }
        /**
         * [toNewarr description] 将数组整理成下拉菜单的数组
         * @param  {[type]} attr  [description]  取出的属性
         * @param  {[type]} array [description]
         * @return {[type]}       [description]
         */
        function toNewarr(attr, attr2, array) {
            for (var index = 0; index < array.length; index++) {
                var temp = array[index];
                for (var j in temp) {
                    if (j != attr && j != attr2) {
                        delete temp[j];
                    }
                }
                temp.value = temp[attr2] || index;
                temp.name = temp[attr];
                delete temp[attr];
                if (!!attr2) {
                    delete temp[attr2];
                }
            }
            return array;
        }

        /**
         * [queryByDropdown description] 下拉框选择
         * @return {[type]} [description]
         */
        $scope.queryByDropdown = function(type, item) {
            var newType = type + 's';
            var typeId = type + 'Id';
            if (item.name == $scope.data[newType][0].name) {
                $scope.data.uploadInfo[type] = '';
                $scope.data.uploadInfo[typeId] = '';
            } else {
                $scope.data.uploadInfo[type] = item.name;
                $scope.data.uploadInfo[typeId] = item.value; //  $scope.data.uploadInfo.diePositionId
            }
            // 根据叠次查版面
            if (type == 'diePosition') {
                $scope.status.diePositionChange = true;
                // 清空版面数据
                delete $scope.data.banPositons;
                $scope.data.banPositons = [
                    {
                        name: '请选择版面',
                        value: '',
                    },
                ];
                $scope.data.banPositon = angular.copy($scope.data.banPositons[0]);
                $scope.data.uploadInfo.banPositon = '';

                // 未选择叠次，不查询版面
                if (!$scope.data.uploadInfo[typeId]) {
                    return;
                }
                editingCenterService.getSiteInfo(paperId).then(function(data) {
                    queryCaiBianBanMians(data);
                });
            }
        };

        /**
         * [getSystemTime description] 获取当前时间
         * @return {[type]} [description]
         */
        function getSystemTime() {
            globleParamsSet.getServerTime().then((data) => {
                var date = new Date(data.LASTOPERTIME);
                $scope.pubDate = date.setDate(date.getDate() + 1);
            });
        }

        $scope.uploadImage = function(files, file, newFiles) {
            var imgType = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            var index = newFiles[0].name.lastIndexOf('.');
            var fileType = newFiles[0].name.slice(index + 1).toLowerCase();
            if (imgType.indexOf(fileType) == -1) {
                modalDialog.alertType('格式不支持', '', 'warning', false);
                return;
            }
            Upload.upload({
                url: '/wcm/openapi/uploadImage',
                data: {
                    file: newFiles[0],
                },
            }).then(function(resp) {
                if (resp.data.success == '上传成功！') {
                    $scope.data.uploadInfo.imageName = resp.data.imgName;
                    $scope.data.uploadInfo.orignalImg = resp.data.orignalImg;
                    $scope.data.uploadInfo.imgSrc = '/wcm/openapi/readimg?FileName=' + resp.data.imgName;
                }
            });
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            var flag = true; // 验证通过
            var arr = ['time', 'banPositon', 'diePosition', 'imgSrc', 'zuPeople'];
            var params = {
                serviceid: 'mlf_dymonitor',
                methodname: 'saveDaYang',
                PAPERID: paperId,
                PICTURE: [],
            };
            var singleImg = {};
            for (var i = 0; i < arr.length; i++) {
                if (!$scope.data.uploadInfo[arr[i]]) {
                    flag = false;
                    $scope.status[arr[i]] = false;
                } else {
                    $scope.status[arr[i]] = true;
                }
            }
            if (!flag) {
                return;
            }
            var today = new Date();
            $scope.data.uploadInfo.uploadTime = $filter('date')(today, 'yyyy-MM-dd');
            window.localStorage['dieciBanmianMermory'] = JSON.stringify({
                dieci: angular.copy($scope.data.diePosition),
                banmian: angular.copy($scope.data.banPositon),
            });
            $scope.data.ALLitems.push($scope.data.uploadInfo);
            for (var i = 0; i < $scope.data.ALLitems.length; i++) {
                var item = $scope.data.ALLitems[i];
                var pubTime = $filter('date')(new Date(item.time), 'yyyy-MM-dd');
                singleImg = {
                    imageName: item.imageName,
                    zhuBanName: item.zuPeople,
                    orignalImg: item.orignalImg,
                    pubTime: pubTime,
                    banmianID: item.banPositonId,
                    dieciID: item.diePositionId,
                };
                params.PICTURE.push(singleImg);
            }
            params.PICTURE = JSON.stringify(params.PICTURE);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.ISSUCCESS) {
                    if ($scope.add) {
                        modalDialog.alertType('添加成功！', '', 'success', false);
                    } else {
                        modalDialog.alertType('编辑成功！', '', 'success', false);
                    }
                    $modalInstance.close($scope.data.uploadInfo);
                }
            });
        };
    },
]);
